import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaDivider from './VaDivider.vue'

export const VaDivider = withConfigTransport(_VaDivider)
